/*
 * サブシステム名：請求
 * 機能名：請求明細一覧
 */

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import DdCheckbox from '@/components/DdCheckbox.vue'
import DdDataTable from '@/components/DdDataTable'
import DdDateBox from '@/components/DdDateBox'
import DdNumericBox from '@/components/DdNumericBox'
import DdQuillEditor from '@/components/DdQuillEditor'
import DdRadioButton from '@/components/DdRadioButton'
import DdRadioSwitchTwoway from '@/components/DdRadioSwitchTwoway'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdSpreadSheet from '@/components/DdSpreadSheet'
import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox.vue'
import DdTextBoxPlaceHolderFree from '@/components/DdTextBoxPlaceHolderFree'

import flowMixin from '@/mixins/flowMixins'

import date from '@/ddv2.library/date'
import modals from '@/ddv2.library/modals'
import filter from '@/rahmen/utils/filters'
import message from '@/ddv2.library/messages'

import { mapGetters } from 'vuex'

export default {
  name: 'SeikyuMeisaiListEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,

    DdCheckbox,
    DdDataTable,
    DdDateBox,
    DdNumericBox,
    DdQuillEditor,
    DdRadioButton,
    DdRadioSwitchTwoway,
    DdRowCountBox,
    DdSpreadSheet,
    DdSubHeader,
    DdTextBox,
    DdTextBoxPlaceHolderFree
  },
  data: () => ({
    rows: [],
    headers: [],
    headerType: 'D2BILD1020',
    recSendMail: {},
    recSendMail1: {},
    recSendMail2: {},
    params: {},
    seikyuKihon: {},
    seikyusaki: {},
    isExistsKeshikomi: false,
    expansionPanel: [0, 1],
    seikyusakiCdNmText: '',
    tokuisakiCdNmText: '',
    eigyoshoCdNmText: '',
    shimeDateText: '',
    seikyushoText: '',
    nippoStyleNormal: false,
    conditions: {
      seikyuYmd: '',
      seikyuYm: '',
      shimeDay: '',
      shiborikomiStartYmd: '',
      shiborikomiEndYmd: '',
      seikyusakiId: '',
      eigyoshoId: '',
      seikyushoKarihakkoFlg: false,
      kingakuZeroFlg: false,
      kingakuKakutei: '01',
      shimebiIgaiHyojiFlg: false,
      seikyuDomeHyojiFlg: false
    },
    seikyuSum: {
      kihonUnchin: 0,
      jikanWarimashiKingaku: 0,
      kyoriWarimashiKingaku: 0,
      warimashiSonotaKingaku: 0,
      unchinHokaKingaku: 0,
      hiwayPrice: 0,
      unchinHokaHikazei: 0,
      nenryoSurcharge: 0,
      tsumikomiKingaku: 0,
      torioroshiKingaku: 0,
      taikiJikanKingaku: 0,
      futaiGyomuKingaku: 0
    },
    itemsPerPage: 100,
    page: 1,
    isXlsDownloader: false,
    modeKengen: 0,
    // 表示制御
    isConditionHide: false,
    dispSeikyusho: '',
    dispSeikyuMeisaiIchiranCsv: '',
    // メール送信ダイアログ
    showMailDialog: false,
    sendKariSeikyushoFlg: true,
    // スプレッドシートオプション
    option: {
      // テーブル最大高さ
      tableHeight: '100%',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列固定
      freezeColumns: 2,
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: false,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: true,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: true,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: true,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: true,
      // ページネーションオプション
      pagination: 25,
      paginationOptions: [10, 25, 50, 100, 150, 200],
      // デフォルト文言変更
      text: {
        show: '1ページ当たりの行数:',
        entries: '',
        showingPage: '全部で {1} ページあります',
        search: 'さらにフリーワードで絞り込む',
        noRecordsFound: '対象データがありません'
      }
    },
    // 画面側からのエラーリスト
    outsideErrorList: []
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      kihonJoho: 'DDMasters/mstKihonJoho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      seikyusakiList: 'DDMasters/mstSeikyusaki',
      addressList: 'DDMasters/mstAddress',
      hinmeiList: 'DDMasters/mstHinmei',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      taxList: 'DDMasters/msysTax',
      userSettings: 'DDMasters/mstUserSettings',
      xlsImportMappingList: 'DDMasters/mstXlsImportMapping',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    viewStyleType () {
      const type = [undefined, null].includes(this.userSettings) || [undefined, null].includes(this.userSettings.useNippoEditTransition) ? 1 : this.userSettings.useNippoEditTransition
      return type
    },
    isOutputButtonDisabled () {
      return this.rows.length === 0
    },
    isBatchRegisterButtonDisabled () {
      if (this.modeKengen !== 2) {
        return false
      }
      const errorRows = this.rows.filter(function (elem) {
        return elem.errFlg === true
      })
      if (errorRows.length > 0) {
        return true
      }

      return false
    },

    isSeikyu () {
      return this.params.seikyusho !== '未出力'
    },
    isSeikyuTorikeshi () {
      return this.params.seikyusho === '取消済'
    },
    isKarihakko () {
      return this.params.kariHakkoFlg
    },
    isNotExistSeikyushoLayoutKbn () {
      return !this.seikyusaki.seikyushoLayoutKbn && !this.seikyusaki.seikyuMeisaishoLayoutKbn
    },
    isNoParam () {
      return Object.keys(this.params).length === 0
    },
    isShoukaiMode () {
      return this.modeKengen === 0
    },
    isBikoButtonDisp () {
      return this.isSeikyu && !this.isNoParam
    },
    isPrintAgainButtonDisp () {
      return this.isSeikyu && !this.isSeikyuTorikeshi && !this.isNoParam
    },
    isCancelButtonDisp () {
      return this.isSeikyu && !this.isSeikyuTorikeshi && !this.isKarihakko && this.modeKengen === 2 && !this.isNoParam
    },
    isPrintButtonDisp () {
      return !this.isSeikyu && !this.isShoukaiMode && !this.isNoParam
    },
    apiPathSearch () {
      var path = ''
      if (this.params.seikyusho === '未出力') {
        // 未請求（受注情報）の場合
        path = '/api/v1/d2bild0020/searchMiSeikyuMeisaiEditList'
      } else {
        path = '/api/v1/d2bild0020/SearchSeikyuMeisaiEditList'
      }
      return path
    },
    seikyushoStatusColor () {
      if (this.conditions.seikyushoKarihakkoFlg) {
        return 'green'
      } else if (this.conditions.seikyusho === '取消済') {
        return 'gray'
      } else if (this.conditions.seikyusho === '出力済') {
        return 'blue'
      } else {
        return 'white'
      }
    },
    seikyushoStatusText () {
      if (this.conditions.seikyushoKarihakkoFlg) {
        return '仮発行済'
      } else if (this.conditions.seikyusho === '取消済') {
        return '取消済'
      } else if (this.conditions.seikyusho === '出力済') {
        return '本発行済'
      } else {
        return '未出力'
      }
    },
    computedColNumList () {
      var result = {}
      this.headers.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    },
    spreadDescription () {
      // 必要に応じて
      // return '<div style="padding:4px;font-weight:bold;color:red;">(*)がある列は必須項目です</div>'
      return null
    },
    allKazeiGokei () {
      let kazeiSum = 0

      this.rows.forEach(item => {
        const fields = [
          'meisaiKihonUnchin',
          'meisaiJikanWarimashiKingaku',
          'meisaiKyoriWarimashiKingaku',
          'meisaiKeisuWarimashiKingaku',
          'meisaiNenryoWarimashiKingaku',
          'meisaiNenryoSurcharge',
          'meisaiTsumikomiKingaku',
          'meisaiTorioroshiKingaku',
          'meisaiTaikiJikanKingaku',
          'meisaiFutaiGyomuKingaku',
          'meisaiFutaiGyomuKingaku1',
          'meisaiFutaiGyomuKingaku2',
          'meisaiFutaiGyomuKingaku3',
          'meisaiFutaiGyomuKingaku4',
          'meisaiFutaiGyomuKingaku5',
          'meisaiFutaiGyomuKingaku6',
          'meisaiFutaiGyomuKingaku7',
          'meisaiFutaiGyomuKingaku8',
          'meisaiFutaiGyomuKingaku9',
          'meisaiFutaiGyomuKingaku10',
          'meisaiUserKingakuKazei1',
          'meisaiUserKingakuKazei2',
          'meisaiUserKingakuKazei3',
          'meisaiUserKingakuKazei4',
          'meisaiUserKingakuKazei5',
          'meisaiUserKingakuKazei6',
          'meisaiUserKingakuKazei7',
          'meisaiUserKingakuKazei8',
          'meisaiUserKingakuKazei9',
          'meisaiUserKingakuKazei10',
          'hinmokuKihonUnchin',
          'hinmokuJikanWarimashiKingaku',
          'hinmokuKyoriWarimashiKingaku',
          'hinmokuKeisuWarimashiKingaku',
          'hinmokuNenryoWarimashiKingaku',
          'hinmokuNenryoSurcharge',
          'hinmokuTsumikomiKingaku',
          'hinmokuTorioroshiKingaku',
          'hinmokuTaikiJikanKingaku',
          'hinmokuFutaiGyomuKingaku',
          'hinmokuFutaiGyomuKingaku1',
          'hinmokuFutaiGyomuKingaku2',
          'hinmokuFutaiGyomuKingaku3',
          'hinmokuFutaiGyomuKingaku4',
          'hinmokuFutaiGyomuKingaku5',
          'hinmokuFutaiGyomuKingaku6',
          'hinmokuFutaiGyomuKingaku7',
          'hinmokuFutaiGyomuKingaku8',
          'hinmokuFutaiGyomuKingaku9',
          'hinmokuFutaiGyomuKingaku10',
          'hinmokuUserKingakuKazei1',
          'hinmokuUserKingakuKazei2',
          'hinmokuUserKingakuKazei3',
          'hinmokuUserKingakuKazei4',
          'hinmokuUserKingakuKazei5',
          'hinmokuUserKingakuKazei6',
          'hinmokuUserKingakuKazei7',
          'hinmokuUserKingakuKazei8',
          'hinmokuUserKingakuKazei9',
          'hinmokuUserKingakuKazei10'
        ]

        fields.forEach(f => {
          if (![undefined, null, '0', ''].includes(item[f])) {
            kazeiSum += Number(item[f])
          }
        })

        // meisaiHanyoKingaku1〜5 は対応する 税区分が '01' の場合のみ加算
        for (let i = 1; i <= 5; i++) {
          const kingakuKey = `meisaiHanyoKingaku${i}`
          const zeiKey = `meisaiHanyoKingakuZeiKbn${i}`
          if (item[zeiKey] === '01' && ![undefined, null, ''].includes(item[kingakuKey])) {
            kazeiSum += Number(item[kingakuKey])
          }
        }

        // hinmokuHanyoKingaku1〜5 は対応する 税区分が '01' の場合のみ加算
        for (let i = 1; i <= 5; i++) {
          const kingakuKey = `hinmokuHanyoKingaku${i}`
          const zeiKey = `hinmokuHanyoKingakuZeiKbn${i}`
          if (item[zeiKey] === '01' && ![undefined, null, ''].includes(item[kingakuKey])) {
            kazeiSum += Number(item[kingakuKey])
          }
        }
      })

      return kazeiSum
    },
    allKazeiGokeiDisp () {
      // 合計金額の表示
      return filter.numericFormatter(this.allKazeiGokei)
    },
    allHikazeiGokei () {
      let hikazeiSum = 0

      this.rows.forEach(item => {
        const fields = [
          'meisaiHiwayPrice',
          'meisaiUserKingakuHikazei1',
          'meisaiUserKingakuHikazei2',
          'meisaiUserKingakuHikazei3',
          'meisaiUserKingakuHikazei4',
          'meisaiUserKingakuHikazei5',
          'meisaiUserKingakuHikazei6',
          'meisaiUserKingakuHikazei7',
          'meisaiUserKingakuHikazei8',
          'meisaiUserKingakuHikazei9',
          'meisaiUserKingakuHikazei10',
          'meisaiUserKingakuUchizei1',
          'meisaiUserKingakuUchizei2',
          'meisaiUserKingakuUchizei3',
          'meisaiUserKingakuUchizei4',
          'meisaiUserKingakuUchizei5',
          'meisaiUserKingakuUchizei6',
          'meisaiUserKingakuUchizei7',
          'meisaiUserKingakuUchizei8',
          'meisaiUserKingakuUchizei9',
          'meisaiUserKingakuUchizei10',
          'hinmokuHiwayPrice',
          'hinmokuUserKingakuHikazei1',
          'hinmokuUserKingakuHikazei2',
          'hinmokuUserKingakuHikazei3',
          'hinmokuUserKingakuHikazei4',
          'hinmokuUserKingakuHikazei5',
          'hinmokuUserKingakuHikazei6',
          'hinmokuUserKingakuHikazei7',
          'hinmokuUserKingakuHikazei8',
          'hinmokuUserKingakuHikazei9',
          'hinmokuUserKingakuHikazei10',
          'hinmokuUserKingakuUchizei1',
          'hinmokuUserKingakuUchizei2',
          'hinmokuUserKingakuUchizei3',
          'hinmokuUserKingakuUchizei4',
          'hinmokuUserKingakuUchizei5',
          'hinmokuUserKingakuUchizei6',
          'hinmokuUserKingakuUchizei7',
          'hinmokuUserKingakuUchizei8',
          'hinmokuUserKingakuUchizei9',
          'hinmokuUserKingakuUchizei10'
        ]

        fields.forEach(f => {
          if (![undefined, null, '0', ''].includes(item[f])) {
            hikazeiSum += Number(item[f])
          }
        })

        // meisaiHanyoKingaku1〜5 は対応する 税区分が '01'以外 の場合のみ加算
        for (let i = 1; i <= 5; i++) {
          const kingakuKey = `meisaiHanyoKingaku${i}`
          const zeiKey = `meisaiHanyoKingakuZeiKbn${i}`
          if (item[zeiKey] !== '01' && ![undefined, null, ''].includes(item[kingakuKey])) {
            hikazeiSum += Number(item[kingakuKey])
          }
        }

        // hinmokuHanyoKingaku1〜5 は対応する 税区分が '01'以外 の場合のみ加算
        for (let i = 1; i <= 5; i++) {
          const kingakuKey = `hinmokuHanyoKingaku${i}`
          const zeiKey = `hinmokuHanyoKingakuZeiKbn${i}`
          if (item[zeiKey] !== '01' && ![undefined, null, ''].includes(item[kingakuKey])) {
            hikazeiSum += Number(item[kingakuKey])
          }
        }
      })

      return hikazeiSum
    },
    allHikazeiGokeiDisp () {
      return filter.numericFormatter(this.allHikazeiGokei)
    },
    taxPrice () {
      const target = filter.dateFormatter(new Date())
      const tax = this.taxList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })

      return Math.round(this.allKazeiGokei * (tax[0].taxPer / 100))
    },
    taxPriceDisp () {
      return filter.numericFormatter(this.taxPrice)
    },
    allUnchinGokeiDisp () {
      // 合計金額の表示
      return filter.numericFormatter(this.allKazeiGokei + this.allHikazeiGokei + this.taxPrice)
    }
  },
  created () {
    this.params = this.$route.params
    // エクセルレイアウトは常に最新を取得
    this.$store.dispatch('DDMasters/truncateMasters', { list: ['mstxlsimportmapping'] }).then(() => {
      this.$store.dispatch('DDMasters/loadMasters', { list: ['mstxlsimportmapping'], version: 1, kinoId: 0 }).then(() => {
        this.initialize()
      })
    })
  },
  mounted () {
    // エクセルレイアウトは常に最新を取得
    this.$store.dispatch('DDMasters/truncateMasters', { list: ['mstxlsimportmapping'] }).then(() => {
      this.$store.dispatch('DDMasters/loadMasters', { list: ['mstxlsimportmapping'], version: 1, kinoId: 0 }).then(() => {
        this.initialize()
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {}
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['mstkihonjoho', 'msttorihikisaki', 'mstseikyusaki', 'mstaddress', 'msthinmei', 'msthacchakuchi', 'msyskubun', 'mstshubetsu', 'msystax'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.setHeader()
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            if (self.isNoParam) {
              // 請求一覧画面からパラメータが渡されていない（当画面をリロードした）場合
              // 請求一覧画面から受け取ったパラメータをキャッシュから再現するようにしている
              self.loadFromCache()
                .then((c) => {
                  self.params = c.value.params || {}
                  resolve()
                })
            } else {
              resolve()
            }
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            self.$nextTick(() => {
            })
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          self.conditions = { ...self.conditions, ...c }
          self.conditions.shimebiIgaiHyojiFlg = c.shimebiIgaiHyojiFlg === 'true'
          self.conditions.seikyuDomeHyojiFlg = c.seikyuDomeHyojiFlg === 'true'
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                // 画面起動時に検索するため、ユーザ保存項目を復元してから検索する
                self.initSearch()
                  .then(() => {
                    resolve()
                  })
                // resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
            this.params = c.cache.value.params || {}
            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
      this.getShimeJisseki()
    },
    initSearch: function () {
      const self = this
      return new Promise(resolve => {
        if (self.isNoParam) { return resolve() }
        self.seikyusakiCdNmText = self.params.seikyusakiCd ? self.params.seikyusakiCd + ':' + self.params.seikyusakiNm : ' '
        self.tokuisakiCdNmText = self.params.seikyusakiCd ? self.params.seikyusakiCd + ':' + self.params.seikyusakiNm : ' '
        self.eigyoshoCdNmText = self.params.eigyoshoCd ? self.params.eigyoshoCd + ':' + self.params.eigyoshoNm : ' '
        // 末日99
        var shimeDateText
        switch (self.params.shimeDay.trim()) {
          case '':
            shimeDateText = 'なし '
            break
          case '99':
            shimeDateText = '末日締め '
            break
          default:
            shimeDateText = self.params.shimeDay.trim() + '日締め '
        }
        self.shimeDateText = shimeDateText + filter.dateFormatter(self.params.shiborikomiStartYmd) + ' ～ ' + filter.dateFormatter(self.params.shiborikomiEndYmd)
        self.seikyushoText = self.params.seikyusho + ' / ' + self.params.seikyuNo

        self.conditions.id = self.params.seikyuId
        self.conditions.seikyuYmd = filter.dateFormatter(self.params.seikyuYmd)
        self.conditions.seikyuYm = self.params.shimeYm ? self.params.shimeYm.trim() : ''
        self.conditions.shimeDay = self.params.shimeDay ? self.params.shimeDay.trim() : ''
        self.conditions.shiborikomiStartYmdString = filter.dateFormatter(self.params.shiborikomiStartYmd)
        self.conditions.shiborikomiStartYmd = self.params.shiborikomiStartYmd
        self.conditions.shiborikomiEndYmdString = filter.dateFormatter(self.params.shiborikomiEndYmd)
        self.conditions.shiborikomiEndYmd = self.params.shiborikomiEndYmd
        self.conditions.torihikisakiCd = self.params.seikyusakiCd ? self.params.seikyusakiCd : ''
        self.conditions.eigyoshoCd = self.params.eigyoshoCd ? self.params.eigyoshoCd : ''
        self.conditions.seikyushoKarihakkoFlg = self.params.kariHakkoFlg
        self.conditions.kingakuZeroFlg = self.params.seikyuZeroFlg
        self.conditions.seikyusho = self.params.seikyusho
        self.conditions.seikyuNo = self.params.seikyuNo ? self.params.seikyuNo.trim() : ''

        self.HttpClient.post(self.apiPathSearch, self.conditions)
          .then((data) => {
            self.setHeader().then(() => {
              self.searchResultMethodCustom(data)
              resolve(data)
            })
          })
      })
    },
    searchResultMethodCustom: function (data) {
      const self = this
      self.rows = []
      // 取消済以外の場合のみ明細表示（取消は明細表示しない）
      if (!self.isSeikyuTorikeshi) {
        // vw_c_d2bild1020だけではないので、配列を分けて設定される
        self.rows = data.payload.vwCD2bild1020List || []
        if (data.payload.tmpMailInfo) {
          self.recSendMail1.toAddress = ![undefined, null, ''].includes(data.payload.tmpMailInfo.toAddress) ? data.payload.tmpMailInfo.toAddress : ''
          self.recSendMail1.ccAddress = ![undefined, null, ''].includes(data.payload.tmpMailInfo.ccAddress) ? data.payload.tmpMailInfo.ccAddress : ''
          self.recSendMail1.bccAddress = ![undefined, null, ''].includes(data.payload.tmpMailInfo.bccAddress) ? data.payload.tmpMailInfo.bccAddress : ''
          self.recSendMail1.mailTitle = ![undefined, null, ''].includes(data.payload.tmpMailInfo.mailTitle) ? data.payload.tmpMailInfo.mailTitle : ''
          self.recSendMail1.mailText = ![undefined, null, ''].includes(data.payload.tmpMailInfo.mailText) ? data.payload.tmpMailInfo.mailText : ''
        }
        if (data.payload.mailInfo) {
          self.recSendMail2.toAddress = ![undefined, null, ''].includes(data.payload.mailInfo.toAddress) ? data.payload.mailInfo.toAddress : ''
          self.recSendMail2.ccAddress = ![undefined, null, ''].includes(data.payload.tmpMailInfo.ccAddress) ? data.payload.tmpMailInfo.ccAddress : ''
          self.recSendMail2.bccAddress = ![undefined, null, ''].includes(data.payload.tmpMailInfo.bccAddress) ? data.payload.tmpMailInfo.bccAddress : ''
          self.recSendMail2.mailTitle = ![undefined, null, ''].includes(data.payload.mailInfo.mailTitle) ? data.payload.mailInfo.mailTitle : ''
          self.recSendMail2.mailText = ![undefined, null, ''].includes(data.payload.mailInfo.mailText) ? data.payload.mailInfo.mailText : ''
        }
      }
      self.rows.map((elem, index) => {
        elem.rowNo = index + 1
        elem.editFlg = false
        elem.errFlg = false
        // スプレッドシート用編集
        // ※数値はsetHeaderにてmask対応済み
        elem.sagyoYoteiYmd = [undefined, null, ''].includes(elem.sagyoYoteiYmd) ? '' : filter.dateFormatter(elem.sagyoYoteiYmd)
        elem.seikyuYoteiYmd = [undefined, null, ''].includes(elem.seikyuYoteiYmd) ? '' : filter.dateFormatter(elem.seikyuYoteiYmd)
        elem.hatsuchiYmd = ![undefined, null, ''].includes(elem.hatsuchiYmd) ? filter.dateFormatter(elem.hatsuchiYmd) : ''
        elem.hatsuchiHms = ![undefined, null, ''].includes(elem.hatsuchiHms) ? (elem.hatsuchiHms).slice(0, 5) : ''
        elem.chakuchiYmd = ![undefined, null, ''].includes(elem.chakuchiYmd) ? filter.dateFormatter(elem.chakuchiYmd) : ''
        elem.chakuchiHms = ![undefined, null, ''].includes(elem.chakuchiHms) ? (elem.chakuchiHms).slice(0, 5) : ''
        elem.hatsuchiNm = [undefined, null, ''].includes(elem.hatsuchiNm) ? '' : elem.hatsuchiNm
        elem.chakuchiNm = [undefined, null, ''].includes(elem.chakuchiNm) ? '' : elem.chakuchiNm
        elem.hinmeiNm = [undefined, null, ''].includes(elem.hinmeiNm) ? '' : elem.hinmeiNm
        elem.unitKbnNm = [undefined, null, ''].includes(elem.unitKbnNm) ? '' : elem.unitKbnNm
        elem.unchinKeisanKbnNm = [undefined, null, ''].includes(elem.unchinKeisanKbnNm) ? '' : elem.unchinKeisanKbnNm
        elem.seikyuShashuSbtNm = [undefined, null, ''].includes(elem.seikyuShashuSbtNm) ? '' : elem.seikyuShashuSbtNm

        // 請求金額関数埋め込み
        const y = index + 1
        elem.seikyuKingakuGokeiFormula = ![undefined, null, ''].includes(self.seikyuKingakuGokeiFormula) ? '=' + self.seikyuKingakuGokeiFormula.replaceAll('{rowNo}', `${y}`) : ''

        return elem
      })

      self.$nextTick(() => {
        const fixedHeaderColumns = self.headers.filter(x => x.fixedHeader).length
        self.$refs.ddSpreadSheet.setFreezeColumns(fixedHeaderColumns > 0 ? fixedHeaderColumns : 2)
      })

      var initSeikyuKihon = {
        konkaiSeikyuKingaku: 0,
        kihonUnchiGokei: 0,
        warimashiKingakuGokei: 0,
        kazeiKingakuGokei: 0,
        konkaiTax: 0,
        hiwayPriceGokei: 0,
        uchizeiKingakuGokei: 0,
        hikazeiKingakuGokei: 0
      }
      var initMstSeikyusaki = {
        seikyushoLayoutKbn: false,
        seikyuMeisaishoLayoutKbn: false
      }

      // 請求基本情報
      if (!self.isSeikyu) {
        // 未請求（受注情報）の場合
        self.seikyuKihon = data.payload.wkSeikyuKihon || initSeikyuKihon
      } else {
        // 請求済（請求情報）の場合
        self.seikyuKihon = data.payload.trSeikyuKihon || initSeikyuKihon
      }
      // 請求先マスタ情報
      self.seikyusaki = data.payload.mstSeikyusaki || initMstSeikyusaki
      // 請求消込存在確認
      self.isExistsKeshikomi = data.payload.isExistsKeshikomi || false

      const cache = {
        rows: self.rows,
        conditions: self.conditions,
        searchText: self.searchText,
        params: self.params
      }
      self.saveToChache(cache)
        .then(() => {
        })
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post(self.apiPathSearch, self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.searchResultMethodCustom(data)
        },
        getSavedInputMethod: function () {
          if (!self.isSeikyu) {
            // 未請求時のみの項目
            return {
              kingakuKakutei: self.conditions.kingakuKakutei,
              shimebiIgaiHyojiFlg: self.conditions.shimebiIgaiHyojiFlg,
              seikyuDomeHyojiFlg: self.conditions.seikyuDomeHyojiFlg
            }
          } else {
            return {}
          }
        },
        isNoMessageModeMethod: function () {
          return true
        }
      }
      this.search(opt)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: self.params
          }
        }
      }

      this.transitionBack(opt)
    },

    /**
     * outputInfo.StyleTypeについて
     * 11:かんたん日報 / 12:通常日報 : VwCD2bild1020Model.ExcelOperation参照
     */
    onXlsOutputButtonClick: function (e) {
      this.isXlsDownloader = true

      var juchuMeisaiIdList = []
      this.rows.forEach((x) => {
        juchuMeisaiIdList.push(x.trJuchuMeisaiId)
      })
      const outputInfo = {
        idList: juchuMeisaiIdList,
        styleType: this.nippoStyleNormal ? 'D2BILD1021' : 'D2BILD1020'
      }

      this.HttpClient
        .requestFileByPost('/api/v1/VwCD2bild1020/ExcelOutput', outputInfo)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('xlsdownload')
          this.isXlsDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '請求明細一覧_' + ts + '.xlsx'
          elem.click()
        })
    },

    /**
     * 一覧ヘッダ作成
     */
    setHeader: function () {
      const self = this
      return new Promise(resolve => {
        // 現在日付取得
        const target = filter.dateFormatter(new Date())

        // --------------------------------------------------------------------------------
        // スプレッド用ドロップダウン作成
        // --------------------------------------------------------------------------------
        // 得意先
        var wkTokuisakiList = ['未選択']
        const mTokuisakiList = self.torihikisakiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
        })
        const tTokuisakiList = mTokuisakiList.map(elem => {
          return elem.torihikisakiNm
        })
        wkTokuisakiList = wkTokuisakiList.concat(tTokuisakiList)

        // 荷受人
        var wkNiukeninList = ['未選択']
        const mNiukeninList = self.torihikisakiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tNiukeninList = mNiukeninList.map(elem => {
          return elem.torihikisakiNm
        })
        wkNiukeninList = wkNiukeninList.concat(tNiukeninList)

        // 発着地
        var wkHacchakuchiList = ['未選択']
        const mHacchakuchiList = self.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tHacchakuchiList = mHacchakuchiList.map(elem => {
          return elem.hacchakuchiNm
        })
        wkHacchakuchiList = wkHacchakuchiList.concat(tHacchakuchiList)

        // 発地
        var wkHatsuchiList = ['未選択']
        const mHatsuchiList = self.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hatsuchiFlg
        })
        const tHatsuchiList = mHatsuchiList.map(elem => {
          return elem.HatsuchiNm
        })
        wkHatsuchiList = wkHatsuchiList.concat(tHatsuchiList)

        // 経由地
        var wkKeiyuchiList = ['未選択']
        const mKeiyuchiList = self.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.keiyuchiFlg
        })
        const tKeiyuchiList = mKeiyuchiList.map(elem => {
          return elem.KeiyuchiNm
        })
        wkKeiyuchiList = wkKeiyuchiList.concat(tKeiyuchiList)

        // 着地
        var wkChakuchiList = ['未選択']
        const mChakuchiList = self.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.chakuchiFlg
        })
        const tChakuchiList = mChakuchiList.map(elem => {
          return elem.ChakuchiNm
        })
        wkChakuchiList = wkChakuchiList.concat(tChakuchiList)

        // 商品
        var wkShohinList = ['未選択']
        const mShohinList = self.hinmeiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tShohinList = mShohinList.map(elem => {
          return elem.hinmeiNm
        })
        wkShohinList = wkShohinList.concat(tShohinList)

        // 品目種別
        var wkHinmokuShubetsuList = ['未選択']
        const mHinmokuShubetsuList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'GVIJ02' && elem.kaishaCd === self.currentKaishaCode
        })
        const tHinmokuShubetsuList = mHinmokuShubetsuList.map(elem => {
          return elem.sbtNm
        })
        wkHinmokuShubetsuList = wkHinmokuShubetsuList.concat(tHinmokuShubetsuList)

        // 単位
        var wkTaniShubetsuList = ['未選択']
        const mTaniShubetsuList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SVI001' && elem.kaishaCd === self.currentKaishaCode
        })
        const tTaniShubetsuList = mTaniShubetsuList.map(elem => {
          return elem.sbtNm
        })
        wkTaniShubetsuList = wkTaniShubetsuList.concat(tTaniShubetsuList)

        // 運賃計算区分
        var wkUnchinKeisanKubunList = ['未選択']
        const mUnchinKeisanKubunList = self.kubunList.filter((elem) => {
          return elem.kbnShuruiCd === 'SFF055' && elem.kaishaCd === self.currentKaishaCode && ['01', '02', '03'].includes(elem.code)
        })
        const tUnchinKeisanKubunList = mUnchinKeisanKubunList.map(elem => {
          return elem.codeNm
        })
        wkUnchinKeisanKubunList = wkUnchinKeisanKubunList.concat(tUnchinKeisanKubunList)

        // 請求車種
        var wkShashuList = ['未選択']
        const mShashuList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'GVI011' && elem.kaishaCd === self.currentKaishaCode
        })
        const tShashuList = mShashuList.map(elem => {
          return elem.sbtNm
        })
        wkShashuList = wkShashuList.concat(tShashuList)

        // --------------------------------------------------------------------------------
        // スプレッド用ヘッダ作成
        // --------------------------------------------------------------------------------
        if (![undefined, null, []].includes(self.headers) && self.headers.length > 0) { return resolve() }

        self.headers = []

        // マスタ情報から自動生成
        self.xlsImportMappingList.filter(function (elem) {
          return elem.formatCd === self.headerType && elem.hyojiFlg === true
        }).sort((a, b) => {
          if (a.columnNo - b.columnNo !== 0) { return a.columnNo - b.columnNo }
          return -1
        }).forEach((elem) => {
          var dropdownList = null
          if (elem.source === 'TokuisakiList') {
            dropdownList = wkTokuisakiList
          } else if (elem.source === 'NiukeninList') {
            dropdownList = wkNiukeninList
          } else if (elem.source === 'HacchakuchiList') {
            dropdownList = wkHacchakuchiList
          } else if (elem.source === 'HatsuchiList') {
            dropdownList = wkHatsuchiList
          } else if (elem.source === 'KeiyuchiList') {
            dropdownList = wkKeiyuchiList
          } else if (elem.source === 'ChakuchiList') {
            dropdownList = wkChakuchiList
          } else if (elem.source === 'ShohinList') {
            dropdownList = wkShohinList
          } else if (elem.source === 'HinmokuShubetsuList') {
            dropdownList = wkHinmokuShubetsuList
          } else if (elem.source === 'TaniSbtList') {
            dropdownList = wkTaniShubetsuList
          } else if (elem.source === 'UnchinKeisanKbnList') {
            dropdownList = wkUnchinKeisanKubunList
          } else if (elem.source === 'ShashuSbtList') {
            dropdownList = wkShashuList
          }

          // 請求金額計算用定義
          if (elem.bindItemNm === 'seikyuKingakuGokeiFormula') {
            self.seikyuKingakuGokeiFormula = elem.formulaStrings
          }

          // ヘッダー作成
          self.headers.push({
            title: elem.columnNm,
            name: elem.bindItemNm,
            type: elem.standardInputFlg !== true ? null : elem.inputType,
            customInput: elem.standardInputFlg === true ? null : elem.inputType,
            validateType: elem.validateType,
            required: false,
            isRequired: elem.requiredFlg,
            readOnly: elem.readonlyFlg,
            autocomplete: elem.autocompleteFlg,
            width: elem.width + 'px',
            source: dropdownList,
            align: elem.align,
            mask: elem.inputSuffix,
            validateIntDigit: elem.inputIntDigit,
            validateDecimalDigit: elem.inputDecimalDigit,
            // headerStyle: elem.headerStyle === null ? undefined : elem.headerStyle,
            tooltip: elem.requiredFlg ? '必須項目' : undefined,
            columnNo: elem.columnNo,
            fixedHeader: elem.fixedHeaderFlg
          })
        })

        resolve()
      })
    },
    /**
     * 品名ドロップダウン設定
     */
    setHinmeiCellSettings: function (colIndex, rowIndex, column) {
      const self = this
      // 現在日付取得
      const target = filter.dateFormatter(new Date())

      // 品目種別返還
      const m = self.shubetsuList.filter(function (item) {
        return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'GVIJ02' && item.sbtNm === self.rows[rowIndex].hinmokuSbtNm
      })
      const hinshuSbt = m.length > 0 ? m[0].sbtCd : null

      // 商品
      var wkShohinList = ['未選択']
      const mShohinList = this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && ([undefined, null, '', hinshuSbt].includes(t.hinshuSbt) || hinshuSbt === null)
      })
      const tShohinList = mShohinList.map(elem => {
        return elem.hinmeiNm
      })
      wkShohinList = wkShohinList.concat(tShohinList)

      // 品名セルの設定
      this.$refs.ddSpreadSheet.jspreadsheetObj.setProperty(this.computedColNumList.hinmeiNm, rowIndex, {
        ...column,
        type: 'dropdown',
        autocomplete: true,
        source: wkShohinList
      })
    },
    // セル変更時
    onSetCustomCell: function (cell, x, y, value, row, column) {
      if (this.computedColNumList.hinmokuSbtNm === Number(x)) {
        const targetColumn = this.headers.find(item => item.name === 'hinmeiNm')
        this.setHinmeiCellSettings(Number(x), y, targetColumn)
      }
    },
    /**
     * 読み取り専用設定
     */
    setReadonlyCell: function (rowData, columnName) {
      if (this.isShoukaiMode) {
        return true
      }
      if (['juchuNo'].includes(columnName)) {
        return true
      }

      return false
    },
    // 行追加
    addRow: function (pos) {
      console.log('addRow')
    },
    // 行削除
    deleteRow: function (pos) {
      console.log('deleteRow')
    },
    /**
     * スプレッドシート変更後イベント
     * @param {*} rowData
     * @param {*} cell
     * @param {*} x
     * @param {*} y
     * @param {*} newValue
     * @param {*} oldValue
     */
    changeAfter (rowData, cell, x, y, newValue, oldValue) {
      // console.log('c', rowData, cell, x, y, newValue, oldValue)

      /*
        請求金額自動計算
       */
      if (this.computedColNumList.hinmokuKihonUnchin || this.computedColNumList.meisaiKihonUnchin) {
        const t = this.kubunList.filter((elem) => {
          return elem.kbnShuruiCd === 'SFF055' && elem.kaishaCd === this.currentKaishaCode
        }).find(x => x.codeNm === this.rows[y].unchinKeisanKbnNm)
        const tUnchinKeisanKbn = t ? t.code : '03'
        const hinmoku = this.computedColNumList.hinmokuKihonUnchin ? 'hinmoku' : ''

        if (Number(x) === this.computedColNumList.juchuSuryo) {
          this.calcKihonUnchinByQuantity(Number(y), hinmoku)
        }
        if (Number(x) === this.computedColNumList.juchuJuryo) {
          this.calcKihonUnchinByWeight(Number(y), hinmoku)
        }
        if (Number(x) === this.computedColNumList.unchinKeisanKbnNm) {
          if (tUnchinKeisanKbn === '01') {
            this.calcKihonUnchinByQuantity(Number(y), hinmoku)
          } else if (tUnchinKeisanKbn === '02') {
            this.calcKihonUnchinByWeight(Number(y), hinmoku)
          } else {
            this.calcKihonUnchinByCharter(Number(y), hinmoku)
          }
        }
        if (Number(x) === this.computedColNumList.tanka) {
          if (tUnchinKeisanKbn === '01') {
            this.calcKihonUnchinByQuantity(Number(y), hinmoku)
          } else if (tUnchinKeisanKbn === '02') {
            this.calcKihonUnchinByWeight(Number(y), hinmoku)
          } else {
            this.calcKihonUnchinByCharter(Number(y), hinmoku)
          }
        }
      }
    },
    calcKihonUnchinByQuantity: function (y, hinmoku) {
      if (![undefined, null, ''].includes(this.rows[y].juchuSuryo) && ![undefined, null, ''].includes(this.rows[y].tanka)) {
        let cell
        const t = this.rows[y].juchuSuryo * this.rows[y].tanka
        if (![undefined, null, ''].includes(hinmoku)) {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.hinmokuKihonUnchin, y)
        } else {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.meisaiKihonUnchin, y)
        }
        this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cell, Math.round(t), true)
      }
    },
    calcKihonUnchinByWeight: function (y, hinmoku) {
      if (![undefined, null, ''].includes(this.rows[y].juchuJuryo) && ![undefined, null, ''].includes(this.rows[y].tanka)) {
        let cell
        const t = this.rows[y].juchuJuryo * this.rows[y].tanka
        if (![undefined, null, ''].includes(hinmoku)) {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.hinmokuKihonUnchin, y)
        } else {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.meisaiKihonUnchin, y)
        }
        this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cell, Math.round(t), true)
      }
    },
    calcKihonUnchinByCharter: function (y, hinmoku) {
      if (![undefined, null, ''].includes(this.rows[y].tanka)) {
        let cell
        if (![undefined, null, ''].includes(hinmoku)) {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.hinmokuKihonUnchin, y)
        } else {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.meisaiKihonUnchin, y)
        }
        this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cell, Math.round(this.rows[y].tanka), true)
      }
    },
    //
    onClickSave: function () {
      console.log(this.rows)
    },

    onCancelButtonClick: function () {
      // 請求消込を行ったデータだった場合、エラー
      if (this.isExistsKeshikomi) {
        this.setInvalidSummaryMessage('BILE0006')
        return false
      }
      // 月次確定処理を行ったデータだった場合、エラー
      if (this.seikyuKihon.trKessanGetsujiKanriId) {
        this.setInvalidSummaryMessage('BZME0001')
        return false
      }
      const p = modals.showConfirm
      p('COMQ0003').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()
        var list = []
        var row = JSON.parse(JSON.stringify(this.conditions))
        // 消込存在確認項目の設定
        row.trSeikyuKeshikomiMeisaiId = this.isExistsKeshikomi ? 0 : null
        list.push(row)
        this.HttpClient.post('/api/v1/d2bild0010/seikyucancel', list)
          .then((data) => {
            if (data.payload) {
              // 取消処理が正常に終了した場合
              this.params.seikyusho = '取消済'
            }
            // 画面再表示
            this.initialize()
            // 完了処理
            // this.Effects.loadComplete()
            if (data.summaryMessage != null) {
              this.setInvalidSummaryMessage(data.summaryMessage.messageCd)
            } else {
              this.setInvalidSummaryMessage('COMI0005')
            }
          })
      })
    },
    onPrintButtonClick: function (seikyushoKarihakkoFlg, downloadFlg, sendMailFlg) {
      console.log('onPrintButtonClick')
      this.clearInvalidMessage(this.$refs)
      if (sendMailFlg) {
        // 宛先
        if ([undefined, null, ''].includes(this.recSendMail.toAddress)) {
          this.$refs.toAddress[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
          return false
        } else if (!this.recSendMail.toAddress.match(/.+@.+\..+/)) {
          this.$refs.toAddress[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0009'))
          return false
        }
        // Cc
        if (![undefined, null, ''].includes(this.recSendMail.ccAddress) && !this.recSendMail.ccAddress.match(/.+@.+\..+/)) {
          this.$refs.ccAddress[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0009'))
          return false
        }
        // Bcc
        if (![undefined, null, ''].includes(this.recSendMail.bccAddress) && !this.recSendMail.bccAddress.match(/.+@.+\..+/)) {
          this.$refs.bccAddress[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0009'))
          return false
        }
      }
      if (this.lastShimeYmd !== '') {
        if (this.seikyuKihon.seikyuYmd <= this.lastShimeYmd) {
          this.setInvalidSummaryMessage('BZME0001')
          return false
        }
      }
      const self = this
      this.loadFromCache()
        .then((c) => {
          if (!self.isSeikyu) {
            // 未請求（受注情報）の場合
            var msgInfo = {}
            if (c.value.conditions.shimebiIgaiHyojiFlg) {
              // 再検索を促すメッセージを表示
              msgInfo = JSON.parse(JSON.stringify(message.getInfo('BILE0007')))
              msgInfo.message = message.get('BILE0007', ['締日以外の未請求も表示する'])
              self.setSummaryMessage(msgInfo)
              return false
            }
            if (c.value.conditions.seikyuDomeHyojiFlg) {
              // 再検索を促すメッセージを表示
              msgInfo = JSON.parse(JSON.stringify(message.getInfo('BILE0007')))
              msgInfo.message = message.get('BILE0007', ['請求止も表示する'])
              self.setSummaryMessage(msgInfo)
              return false
            }
          }
          self.Effects.loadStart()
          self.dispSeikyusho = `請求書_${self.getTimeStamp()}.pdf`
          // 請求番号は画面再検索時のキーとなりうる項目のため、帳票出力（請求作成）後に対象となった請求番号を取得する必要がある
          var conditions = JSON.parse(JSON.stringify(c.value.conditions))
          var pathPrint = ''
          var pathNoPrint = ''
          if (seikyushoKarihakkoFlg) {
            // 請求書仮発行の場合
            conditions.seikyushoKarihakkoFlg = true
            pathPrint = '/api/v1/d2bild0010/printBillKariMulti'
            pathNoPrint = '/api/v1/d2bild0010/createseikyudatakari'
          } else {
            // 請求書発行の場合
            pathPrint = '/api/v1/d2bild0010/printBillMulti'
            pathNoPrint = '/api/v1/d2bild0010/createseikyudata'
          }

          if (self.isNotExistSeikyushoLayoutKbn) {
            // 請求レイアウト区分が設定されていない場合
            return self.HttpClient
              // 発行処理前の請求No一覧を取得
              .post('/api/v1/d2bild0020/searchseikyunofromseikyu', conditions)
              .then((before) => {
                var beforeResult = before.payload || []
                self.HttpClient
                  // 非帳票出力処理（請求作成のみ）
                  .post(pathNoPrint, c.value.conditions)
                  .then(data => {
                    // 発行処理後の請求No一覧を取得（発行処理対象の請求Noを抽出）
                    self.searchSeikyuNoAfter(c, conditions, seikyushoKarihakkoFlg, beforeResult)
                  })
              })
          } else {
            return self.HttpClient
              // 発行処理前の請求No一覧を取得
              .post('/api/v1/d2bild0020/searchseikyunofromseikyu', conditions)
              .then((before) => {
                var beforeResult = before.payload || []
                c.value.conditions.seikyushoLayoutKbn = self.seikyusaki.seikyushoLayoutKbn
                c.value.conditions.seikyuMeisaishoLayoutKbn = self.seikyusaki.seikyuMeisaishoLayoutKbn
                self.HttpClient.post(pathPrint, [c.value.conditions])
                  .then((data) => {
                    const printDataList = data.payload
                    if (printDataList.length === 0) {
                      self.loadFromCache()
                        .then((c) => {
                          // 発行処理後の請求No一覧を取得（発行処理対象の請求Noを抽出）
                          self.searchSeikyuNoAfter(c, conditions, seikyushoKarihakkoFlg, beforeResult)
                        })
                        .then(() => {
                          if (data.summaryMessage) {
                            data.isValid ? self.setInvalidSummaryMessage('BILE0008') : self.setInvalidSummaryMessage(data.summaryMessage.messageCd)
                          } else {
                            self.setInvalidSummaryMessage('BILE0008')
                          }
                          self.Effects.loadComplete()
                        })
                    } else {
                      let cnt = 0
                      if (downloadFlg) {
                        printDataList.forEach(p => {
                          self.HttpClient.requestFileByPostReturnData('/api/v1/d2bild0010/downloadBill', p).then((param) => {
                            // aタグにファイル仕込んでClickする処理
                            const blob = new Blob([param.data], { type: 'application/pdf' })
                            const elem = document.getElementById('seikyushoDownload')
                            const targetSeikyuNo = param.headers['content-disposition'].match(/filename=(.*);/)[1]
                            const printData = printDataList.find((p) => {
                              return p.seikyuNo === targetSeikyuNo
                            })
                            elem.download = `${printData.seikyuYm}月度_${printData.torihikisakiNm}_請求書_${self.getTimeStamp()}.pdf`
                            elem.href = window.URL.createObjectURL(blob)
                            elem.click()
                            cnt++
                            if (cnt === printDataList.length) {
                              self.loadFromCache()
                                .then((c) => {
                                  // 発行処理後の請求No一覧を取得（発行処理対象の請求Noを抽出）
                                  self.searchSeikyuNoAfter(c, conditions, seikyushoKarihakkoFlg, beforeResult)
                                })
                                .then(() => {
                                  if (data.summaryMessage) {
                                    data.isValid ? self.setInvalidSummaryMessage('COMI0007') : self.setInvalidSummaryMessage(data.summaryMessage.messageCd)
                                  } else {
                                    self.setInvalidSummaryMessage('COMI0007')
                                  }
                                  self.Effects.loadComplete()
                                })
                            }
                          })
                        })
                      }
                      if (sendMailFlg) {
                        printDataList.forEach(p => {
                          self.Effects.loadStart()
                          self.recSendMail.seikyuNo = p.seikyuNo
                          self.recSendMail.filePath = p.path
                          self.HttpClient.post('/api/v1/D2bild0020/SendInvoiceByMail', self.recSendMail).then((data) => {
                            if (data) {
                              if (data.summaryMessage) {
                                modals.showSuccess(data.summaryMessage).then(() => {
                                  self.showMailDialog = false
                                  // 再検索実行
                                  self.searchSeikyuNoAfter(c, conditions, seikyushoKarihakkoFlg, beforeResult)
                                })
                              }
                            } else {
                              modals.showError('請求書の送付に失敗しました')
                            }
                          })
                          self.Effects.loadComplete()
                        })
                      }
                    }
                  })
              })
          }
        })
    },
    searchSeikyuNoAfter: function (c, conditions, seikyushoKarihakkoFlg, beforeResult) {
      console.log('searchSeikyuNoAfter')
      this.HttpClient
        .post('/api/v1/d2bild0020/searchseikyunofromseikyu', conditions)
        .then((after) => {
          var afterResult = after.payload || []
          var result = afterResult.filter((elem) => {
            return beforeResult.indexOf(elem) === -1
          })
          if (result.length > 0) {
            // 請求情報が作成された場合
            // paramsの値を処理後の情報に更新
            this.params.seikyusho = '出力済'
            // 請求番号を取得
            this.params.seikyuNo = result[0]
            if (seikyushoKarihakkoFlg) {
              // 請求書仮発行の場合
              this.params.kariHakkoFlg = true
            }
            // 画面再検索のために再キャッシュ
            const cache = {
              rows: c.value.rows,
              conditions: c.value.conditions,
              searchText: c.value.searchText,
              params: this.params
            }
            this.saveToChache(cache)
              .then(() => {
              })
            // 画面再表示
            this.initialize()
            // 完了処理
            // this.Effects.loadComplete()
            this.setInvalidSummaryMessage('COMI0005')
          } else {
            // 完了処理
            this.Effects.loadComplete()
            this.setInvalidSummaryMessage('COMI0005')
          }
        })
    },
    onPrintAgainButtonClick: function (sendMailFlg) {
      this.clearSummaryMessage()

      this.Effects.loadStart()
      const self = this
      this.loadFromCache()
        .then((c) => {
          self.dispSeikyusho = `請求書_${self.getTimeStamp()}.pdf`
          // 請求番号は画面再検索時のキーとなりうる項目のため、帳票出力（請求作成）後に対象となった請求番号を取得する必要がある
          c.value.conditions.seikyushoKarihakkoFlg = self.sendKariSeikyushoFlg
          c.value.conditions.seikyushoLayoutKbn = self.seikyusaki.seikyushoLayoutKbn
          c.value.conditions.seikyuMeisaishoLayoutKbn = self.seikyusaki.seikyuMeisaishoLayoutKbn

          this.HttpClient.post('/api/v1/d2bild0010/printBillAgainMulti', [c.value.conditions])
            .then((data) => {
              const pathList = data.payload
              if (pathList.length === 0) {
                self.loadFromCache()
                  .then(() => {
                    if (data.summaryMessage) {
                      data.isValid ? self.setInvalidSummaryMessage('BILE0008') : self.setInvalidSummaryMessage(data.summaryMessage.messageCd)
                    } else {
                      self.setInvalidSummaryMessage('BILE0008')
                    }
                    self.Effects.loadComplete()
                  })
              } else {
                let cnt = 0
                if ([undefined, null, false].includes(sendMailFlg)) {
                  pathList.forEach(p => {
                    self.HttpClient.requestFileByPostReturnData('/api/v1/d2bild0010/downloadBill', p).then((param) => {
                      // self.dispSeikyusho = `${p.seikyuYm}月度_${p.torihikisakiNm}_請求書_${self.getTimeStamp()}.pdf`
                      // aタグにファイル仕込んでClickする処理
                      const blob = new Blob([param.data], { type: 'application/pdf' })
                      const elem = document.getElementById('seikyushoDownload')
                      const targetSeikyuNo = param.headers['content-disposition'].match(/filename=(.*);/)[1]
                      const printData = pathList.find((p) => {
                        return p.seikyuNo === targetSeikyuNo
                      })
                      elem.download = `${printData.seikyuYm}月度_${printData.torihikisakiNm}_請求書_${self.getTimeStamp()}.pdf`
                      elem.href = window.URL.createObjectURL(blob)
                      elem.click()

                      cnt++
                      if (cnt === pathList.length) {
                        self.loadFromCache()
                          .then((c) => {
                            self.conditions = c.value.conditions || {}
                            self.onSearchButtonClick()
                          })
                          .then(() => {
                            if (data.summaryMessage) {
                              data.isValid ? self.setInvalidSummaryMessage('COMI0007') : self.setInvalidSummaryMessage(data.summaryMessage.messageCd)
                            } else {
                              self.setInvalidSummaryMessage('COMI0007')
                            }
                            self.Effects.loadComplete()
                          })
                      }
                    })
                  })
                } else {
                  pathList.forEach(p => {
                    self.Effects.loadStart()
                    self.recSendMail.seikyuNo = p.seikyuNo
                    self.recSendMail.filePath = p.path
                    self.HttpClient.post('/api/v1/D2bild0020/SendInvoiceByMail', self.recSendMail).then((data) => {
                      if (data) {
                        if (data.summaryMessage) {
                          modals.showSuccess(data.summaryMessage).then(() => {
                            self.showMailDialog = false
                          })
                        }
                      } else {
                        modals.showError('請求書の送付に失敗しました')
                      }
                    })
                    self.Effects.loadComplete()
                  })
                }
              }
            })
        })
    },
    searchValidate: function () {
      return true
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    },
    getShimeJisseki: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get('/api/v1/TrKessanGetsujiKanri/GetAll')
          .then((data) => {
            if (data.payload) {
              var seikyuShimeList = data.payload.map((elem) => {
                elem.taishoShimeYmd = new Date(elem.taishoYm + '/' + elem.taishoShimeDay)
                return elem
              }).filter(function (elem) {
                return elem.taishoGyomuCd === '01' && elem.delFlg === false
              })
              this.lastShimeYmd = seikyuShimeList.length !== 0 ? filter.dateFormatter(seikyuShimeList[seikyuShimeList.length - 1].taishoShimeYmd) : ''
            }
            resolve()
          })
      })
    },

    /**
     * 保存処理（ソースが酷いのでそのうち直す）
     * @returns
     */
    onSaveButtonClick: function () {
      const self = this

      // 請求書発行済みの場合は保存処理を実行させない
      if (![undefined, null, ''].includes(this.conditions.seikyuNo)) {
        modals.showAlert('BILI0001')
        return
      }

      // 変更フラグONのみ対象
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.errFlg !== true
      })
      if (saveTargetRow.length < 1) {
        modals.showAlert('COMI0010')
        return
      }

      const parm = [saveTargetRow.length]
      modals.showConfirmYesNo('BILQ0001', null, null, parm).then((ok) => {
        // 処理を続行しない場合は終了
        if (ok === true) {
          /**
           * リスト項目テキスト⇒ID/Code変換
           */
          // 荷受人
          saveTargetRow.filter((elem) => {
            return ![undefined, null].includes(elem.niukeninNm)
          }).map((elem) => {
            const m = self.torihikisakiList.filter(function (item) {
              return item.torihikisakiNm === elem.niukeninNm
            })
            if (m.length > 0) {
              elem.niukeninId = m[0].id
            } else {
              elem.niukeninId = null
            }
            return elem
          })

          // 発地
          saveTargetRow.filter((elem) => {
            return ![undefined, null].includes(elem.hatsuchiNm)
          }).map((elem) => {
            const m = self.hacchakuchiList.filter(function (item) {
              return item.hacchakuchiNm === elem.hatsuchiNm
            })
            if (m.length > 0) {
              elem.hatsuchiId = m[0].id
            } else {
              elem.hatsuchiId = null
            }
            return elem
          })

          // 着地
          saveTargetRow.filter((elem) => {
            return ![undefined, null].includes(elem.chakuchiNm)
          }).map((elem) => {
            const m = self.hacchakuchiList.filter(function (item) {
              return item.hacchakuchiNm === elem.chakuchiNm
            })
            if (m.length > 0) {
              elem.chakuchiId = m[0].id
            } else {
              elem.chakuchiId = null
            }
            return elem
          })

          // 品目種別
          saveTargetRow.filter((elem) => {
            return ![undefined, null].includes(elem.hinmokuSbtNm)
          }).map((elem) => {
            const m = self.shubetsuList.filter(function (item) {
              return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'GVIJ02' && item.sbtNm === elem.hinmokuSbtNm
            })
            if (m.length > 0) {
              elem.hinmokuSbt = m[0].sbtCd
            } else {
              elem.hinmokuSbt = null
            }
            return elem
          })

          // 商品
          saveTargetRow.filter((elem) => {
            return ![undefined, null].includes(elem.hinmeiNm)
          }).map((elem) => {
            const m = self.hinmeiList.filter(function (item) {
              return item.hinmeiNm === elem.hinmeiNm
            })
            if (m.length > 0) {
              elem.mstHinmeiId = m[0].id
            } else {
              elem.mstHinmeiId = null
            }
            return elem
          })

          // 単位
          saveTargetRow.filter((elem) => {
            return ![undefined, null].includes(elem.unitKbnNm)
          }).map((elem) => {
            const m = self.shubetsuList.filter(function (item) {
              return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'SVI001' && item.sbtNm === elem.unitKbnNm
            })
            if (m.length > 0) {
              elem.unitKbn = m[0].sbtCd
            } else {
              elem.unitKbn = null
            }
            return elem
          })

          // 運賃計算区分
          saveTargetRow.filter((elem) => {
            return ![undefined, null].includes(elem.unchinKeisanKbnNm)
          }).map((elem) => {
            const m = self.kubunList.filter(function (item) {
              return item.kaishaCd === self.currentKaishaCode && item.kbnShuruiCd === 'SFF055' && item.codeNm === elem.unchinKeisanKbnNm
            })
            if (m.length > 0) {
              elem.unchinKeisanKbn = m[0].code
            } else {
              elem.unchinKeisanKbn = null
            }
            return elem
          })

          // 請求車種
          saveTargetRow.filter((elem) => {
            return ![undefined, null].includes(elem.seikyuShashuSbtNm)
          }).map((elem) => {
            const m = self.shubetsuList.filter(function (item) {
              return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'GVI011' && item.sbtNm === elem.seikyuShashuSbtNm
            })
            if (m.length > 0) {
              elem.seikyuShashuSbt = m[0].sbtCd
            } else {
              elem.seikyuShashuSbt = null
            }
            return elem
          })

          /**
           * 保存処理
           */
          this.targetList = saveTargetRow
          this.$nextTick(function () {
            self.saveAction()
          })
        }
      })
    },
    saveAction: function () {
      const self = this
      const opt = {
        registerRequestPromise: function () {
          return self.HttpClient.post('/api/v1/d2bild0020/BulkRegistration', self.targetList)
        },
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.Effects.loadComplete()
            if (data.isValid) {
              var param = [data.payload.length]
              self.$nextTick(function () {
                modals.showAlertOk('BILI0002', null, null, param).then((ok) => {
                  self.onSearchButtonClick()
                })
              })
            }
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return false
        },
        getSavedInputMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    // 登録前チェック
    registerValidate: function () {
      const self = this
      /*
      const filledRows = this.rows
        .map((row, rowIndex) => ({ row, rowIndex }))
        .filter(({ row }) =>
          Object.values(row).some(value => value !== null && value !== '')
        )
      */
      const filledRows = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.errFlg !== true
      })

      let noProblem = true

      filledRows.forEach((row, rowIndex) => {
        self.headers.forEach((col, colIndex) => {
          if (col.isRequired) {
            const cellValue = row[col.name]
            const isEmpty = cellValue === null || cellValue === ''
            const cellName = self.$refs.ddSpreadSheet.getCellNameFromCoords(colIndex, row.rowNo - 1)

            if (isEmpty) {
              noProblem = false
              // 見た目にわかるよう赤背景をつける
              self.$refs.ddSpreadSheet.jspreadsheetObj.setStyle(cellName, 'background-color', '#ffcccc')
            } else {
              // 問題なければ背景を戻す（任意）
              self.$refs.ddSpreadSheet.jspreadsheetObj.setStyle(cellName, 'background-color', '')
            }
          }
        })
      })

      return noProblem
    },

    // --------------------------------------------------------------------------------
    // メール送信ダイアログ
    // --------------------------------------------------------------------------------
    onOpenSendMailDialogClick: function (kariHakkoFlg, resendFlg) {
      console.log('onOpenSendMailDialogClick')
      this.showMailDialog = true
      this.sendKariSeikyushoFlg = kariHakkoFlg
      this.recSendMail.eigyoshoCd = this.conditions.eigyoshoCd
      this.recSendMail.toAddress = kariHakkoFlg ? this.recSendMail1.toAddress : this.recSendMail2.toAddress
      this.recSendMail.ccAddress = kariHakkoFlg ? this.recSendMail1.ccAddress : this.recSendMail2.ccAddress
      this.recSendMail.bccAddress = kariHakkoFlg ? this.recSendMail1.bccAddress : this.recSendMail2.bccAddress
      this.recSendMail.mailTitle = kariHakkoFlg ? this.recSendMail1.mailTitle : this.recSendMail2.mailTitle
      if (resendFlg) {
        this.recSendMail.mailTitle = this.recSendMail.mailTitle + '【再送】'
      }
      this.recSendMail.mailText = kariHakkoFlg ? this.recSendMail1.mailText : this.recSendMail2.mailText
      this.recSendMail.mailTemplateCd = kariHakkoFlg ? 'BIL010' : 'BIL011'
    },

    onChangeListType: function (type) {
      this.nippoStyleNormal = type
      if (type) {
        this.headerType = 'D2BILD1021'
      } else {
        this.headerType = 'D2BILD1020'
      }
      const p = Object.assign([], this.rows)
      this.headers = []
      this.rows = []
      this.setHeader().then(() => {
        this.rows = Object.assign([], p)
        this.rows.map((elem, index) => {
          // 請求金額関数埋め込み
          const y = index + 1
          elem.seikyuKingakuGokeiFormula = ![undefined, null, ''].includes(this.seikyuKingakuGokeiFormula) ? '=' + this.seikyuKingakuGokeiFormula.replaceAll('{rowNo}', `${y}`) : ''
          return elem
        })
        this.$nextTick(() => {
          const fixedHeaderColumns = this.headers.filter(x => x.fixedHeader).length
          this.$refs.ddSpreadSheet.setFreezeColumns(fixedHeaderColumns > 0 ? fixedHeaderColumns : 2)
        })
      })
    },
    // ダミー
    dummyFunction: function () {
    }
  }
}
